import {ApiService} from '../ApiService'
import {
  DeleteXpertKnowledgeBody,
  UpdateXpertKnowledgeBody,
  XpertKnowledgeAssetsDto,
  XpertKnowledgeDto,
  TryPromptXpertKnowledgeTutorialBody,
  SortByEnum,
} from './type'
import {XpertKnowledgeTutorialDto} from '../XpertKnowledgeTutorial/type'
import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {PagesInfo} from '../PagesInfo/type'
import {UserDto} from '../User/type'

class XpertKnowledgeServiceProvider extends ApiService {
  async getAll(): Promise<PagesInfo<XpertKnowledgeDto>> {
    return this.get<PagesInfo<XpertKnowledgeDto>>(`/xpert-knowledge`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAllCreator(): Promise<UserDto[]> {
    return this.get<UserDto[]>('/xpert-knowledge/creators', {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAllEquipmentTypes(): Promise<string[]> {
    return this.get<string[]>('/xpert-knowledge/equipment-types', {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAllPublish(
    creatorId?: number,
    equipmentType?: string,
    startTimestamp?: string,
    endTimestamp?: string,
    sortBy?: SortByEnum,
    page?: number,
    size?: number,
    title?: string
  ): Promise<PagesInfo<XpertKnowledgeDto>> {
    const params = new URLSearchParams()

    if (creatorId) {
      params.append('creatorId', creatorId.toString())
    }

    if (equipmentType) {
      params.append('equipmentType', equipmentType)
    }

    if (startTimestamp && endTimestamp) {
      params.append('startTimestamp', startTimestamp)
      params.append('endTimestamp', endTimestamp)
    }

    if (sortBy) {
      params.append('sortBy', sortBy)
    }

    if (page) {
      params.append('page', page.toString())
    }

    if (size) {
      params.append('size', size.toString())
    }

    if (title) {
      params.append('title', title)
    }

    const queryString = params.toString()
    const endpoint = `/xpert-knowledge/publish${queryString ? `?${queryString}` : ''}`

    return this.get<PagesInfo<XpertKnowledgeDto>>(endpoint, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAllUnpublish(page?: number, size?: number): Promise<PagesInfo<XpertKnowledgeDto>> {
    const params = new URLSearchParams()

    if (page) {
      params.append('page', page.toString())
    }

    if (size) {
      params.append('size', size.toString())
    }

    const queryString = params.toString()
    return this.get<PagesInfo<XpertKnowledgeDto>>(`/xpert-knowledge/unpublish${queryString ? `?${queryString}` : ''}`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getById(xpertKnowledgeId: string): Promise<XpertKnowledgeDto> {
    return this.get<XpertKnowledgeDto>(`/xpert-knowledge/${xpertKnowledgeId}`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async destroy(body: DeleteXpertKnowledgeBody): Promise<void> {
    return this.delete<void>(`/xpert-knowledge`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async update(body: UpdateXpertKnowledgeBody): Promise<XpertKnowledgeDto> {
    return this.patch<XpertKnowledgeDto>(`/xpert-knowledge`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async tryPrompt(xpertKnowledgeId: string, body: TryPromptXpertKnowledgeTutorialBody): Promise<XpertKnowledgeTutorialDto> {
    return this.post<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/generator/internal-generate`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getAssets(xpertKnowledgeId: string): Promise<XpertKnowledgeAssetsDto> {
    return this.get<XpertKnowledgeAssetsDto>(`/xpert-knowledge/${xpertKnowledgeId}/assets`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeService = new XpertKnowledgeServiceProvider()
